<template>
    <div>
        <keep-alive>
            <component v-if="postLoaded" class="main flex flex-col" :is="page" />
            <div v-else>not loaded</div>
        </keep-alive>
        <div class="mx-auto flex flex-row justify-between text-lg w-2/12 my-16 text-center">
            <router-link class="mx-auto" :to="`/resumo-executivo`">Voltar ao índice</router-link>
        </div>
    </div>
</template>

<script>
export default {
    props: ['slug', 'issue', 'componentName', 'author', 'fa', 'idx'],
    components: {
        Texto1PT: () => import('@/components/Summary/PT/Texto1PT'),
        Texto2PT: () => import('@/components/Summary/PT/Texto2PT'),
        Texto3PT: () => import('@/components/Summary/PT/Texto3PT'),
        Texto4PT: () => import('@/components/Summary/PT/Texto4PT'),
        Texto5PT: () => import('@/components/Summary/PT/Texto5PT'),
        Texto6PT: () => import('@/components/Summary/PT/Texto6PT'),
        Texto7PT: () => import('@/components/Summary/PT/Texto7PT'),
        Texto8PT: () => import('@/components/Summary/PT/Texto8PT'),
        Texto9PT: () => import('@/components/Summary/PT/Texto9PT'),
        Texto10PT: () => import('@/components/Summary/PT/Texto10PT'),
    },
    data() {
        return {
            postLoaded: false,
            page: null,
        }
    },
    mounted() {
        if (this.$route.name == 'SingleExecSumView') {
            this.renderPost()
        }
    },
    methods: {
        renderPost() {
            // console.log(Texto1PT)
            this.postLoaded = true
            let currentPostIdx = this.$route.params.idx
            console.log(currentPostIdx)
            // let currentPostObj = currentIssuePosts.filter((e) => e.postSlug === currentPostSlug)

            this.page = `Texto${currentPostIdx}PT`
        },
        loadComp() {},
    },
    watch: {
        $route: function (to, from) {
            if (this.$route.name == 'SingleExecSumView') {
                this.renderPost()
            }
        },
        page: function () {
            this.postLoaded = true
            return this.comp
        },
    },
}
</script>

<style lang="postcss" scoped>
.summary_kicker {
    @apply block uppercase z-50 text-base text-offwhite;
}
.main .post_feature {
    @apply relative h-[25rem] md:h-screen bg-no-repeat bg-cover bg-center w-full -mt-20 flex items-center bg-black bg-local lg:bg-fixed;
}
.main .post_feature::after {
    content: ' ';
    filter: multiply;
    @apply absolute top-0 left-0 bg-black w-full h-full opacity-40;
}
.post_feature_caption,
.post_feature_credits {
    @apply px-4;
}
.post_feature_credits {
    @apply text-gray;
}
</style>
